import { Panel } from "./shared";
import { PageOrderPanel } from "./PageOrderPanel";

export const PagesPanel = ({ thumbs, pageOrder, selectedPages, onToggle, onReorder, onMove, pageRange, onPageRange }) => (
  <Panel>
    {pageOrder.length > 0 && (
      <PageOrderPanel
        thumbs={thumbs}
        order={pageOrder}
        selectedPages={selectedPages}
        onToggle={onToggle}
        onReorder={onReorder}
        onMove={onMove}
      />
    )}
    <input
      value={pageRange}
      onChange={(e) => onPageRange(e.target.value)}
      placeholder={pageOrder.length ? "Advanced range override — optional" : "Pages to keep — e.g. 1-3, 5, 8-12"}
      data-testid="page-range-input"
      className="w-full border border-hairline rounded-lg bg-page px-4 py-2.5 font-mono text-xs text-ink placeholder:text-mist focus:outline-none focus:border-azure transition-colors duration-300"
    />
  </Panel>
);
